import Link from 'next/link';
import { combineClassNames, Flex } from '@arkestro/arkestro-design-system';
import { RightOutlined } from '@ant-design/icons';
import { MenuItem } from '@components/layout/SideMenu/types';
import styles from './LinkItem.module.scss';

interface Props {
  childrenArray?: MenuItem[];
  className?: string;
  collapsed: boolean;
  iconClasses?: string[];
  item: MenuItem;
  labelClasses?: string[];
}

export const LinkItem = ({ className = '', iconClasses = [], item, labelClasses = [], childrenArray, collapsed }: Props) => {
  const { icon, path = '', rel = '', target = '', text, onClick } = item;
  const hasChildren = childrenArray && childrenArray.length > 0;

  const linkContent = (
    <span data-testid={item.id}>
      <Flex justify='space-between'>
        <div>
          {icon && (<div className={combineClassNames(iconClasses)}>{icon}</div>)}
          <span className={combineClassNames(labelClasses)}>{text}</span>
        </div>
        {!collapsed && hasChildren &&
          <div className={styles.chevron} data-testid='open-submenu-icon'>
            <RightOutlined className={styles.chevron} />
          </div>}
      </Flex>
    </span>
  );

  if (hasChildren) {
    return (
      <div className={combineClassNames(className, styles.mainNav)} data-testid='link-item'>
        <Link href={path as string} onClick={onClick} rel={rel} target={target}>
          {linkContent}
        </Link>
        <div className={styles.subNav} data-testid={`${item.id}-sub-menu`}>
          <div className={styles.subMenuWrapper}>
            {childrenArray.map(child => (
              <Flex
                key={child.id}
                className={styles.subNavItem}
                data-testid={`${child.id}-sub-menu-item`}
                onClick={() => { if (child.onClick) child.onClick(); }}
                title={child.text as string}
              >
                {child.text}
              </Flex>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <Link
      className={className}
      data-testid='link-item'
      href={path as string}
      onClick={onClick}
      rel={rel}
      target={target}
    >
      {linkContent}
    </Link>
  );
};
